import { render, staticRenderFns } from "./picInfo.vue?vue&type=template&id=78694bb7&scoped=true&"
import script from "./picInfo.vue?vue&type=script&lang=js&"
export * from "./picInfo.vue?vue&type=script&lang=js&"
import style0 from "./picInfo.vue?vue&type=style&index=0&id=78694bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78694bb7",
  null
  
)

export default component.exports